import './utils/newRelicBrowser';
import '@tkww/orion-web-app-kernel/init';
import React from 'react';
import ReactDOM from 'react-dom/client';
import HoneyBadger from '@honeybadger-io/js';
import {PageletHTMLElement} from '@tkww/orion-web-lib-pagelet';
import {QueryClientProvider} from '@tanstack/react-query';
import {MemberContextProvider} from './contexts/MemberContext';
import {RegistryContextProvider} from './contexts/RegistryContext';
import {queryClient} from './queries';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import filterHoneybadgerNotices from './utils/honeybadger';
import './assets/scss/global.scss';

const honeyBadgerConf = {
  apiKey: process.env.HONEYBADGER_API_KEY,
  environment: process.env.ENV,
  revision: process.env.LATEST_COMMIT_SHA,
  developmentEnvironments: ['qa'],
};

HoneyBadger.configure(honeyBadgerConf);

HoneyBadger.beforeNotify(filterHoneybadgerNotices);

if (
  typeof window !== 'undefined' &&
  window.customElements &&
  !window.customElements.get('ow-pagelet')
) {
  window.customElements.define('ow-pagelet', PageletHTMLElement);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <MemberContextProvider>
        <RegistryContextProvider>
          <App />
        </RegistryContextProvider>
      </MemberContextProvider>
    </QueryClientProvider>
  </ErrorBoundary>,
);
